import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrderReport  {
    _originalTypeClassName = "ekylikeio.BO.OrderReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrderReport.translate = translateService;
}
this.Lines = [];
this.Schools = [];
this.Totals = [];
this.From = null;
this.To = null;
this.GroupBreaks = false;
this.Title = null;
this.Subtitle = null;
this.SeperateFilePerSchool = false;
this.OrderReportKey = null;
this._key = this.OrderReportKey = 0; 
}

static translate: TranslateService;
_key: any;
From:any;
To:any;
GroupBreaks:any;
Title:any;
Subtitle:any;
SeperateFilePerSchool:any;
Lines:any;
Schools:any;
Totals:any;
private _OrderReportKey:any;
get OrderReportKey(): any {
    return this._OrderReportKey;
  }
set OrderReportKey(value: any) {
    this._OrderReportKey = value;
    this._key = value;
  }
static setLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.Lines == null) $this.Lines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Lines.length > 0) {
                    Domain.OrderReport.removeLines($this, $this.Lines[0]);
                }

                Domain.OrderReport.addManyLines($this, copyItems);
            }
static addManyLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OrderReport.addLines($this, items[i]);
                }
            }
static addLines = ($this, item) => {
                if ($this.Lines == null) $this.Lines = [];
                if (item == null || $this.Lines.indexOf(item) > -1) return;
                $this.Lines.push(item);
}
static addRangeLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OrderReport.addLines($this, item));
            }
static removeLines = ($this, item) => {
                if ($this == null || $this.Lines == null || $this.Lines.indexOf(item) === -1) return;
                var _index = $this.Lines.indexOf(item);
                $this.Lines.splice(_index, 1);
}
static clearLines = ($this) => { $this.Lines = null; }
static setSchools = ($this, items) => {
                if (items == null) items = [];
                if ($this.Schools == null) $this.Schools = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Schools.length > 0) {
                    Domain.OrderReport.removeSchools($this, $this.Schools[0]);
                }

                Domain.OrderReport.addManySchools($this, copyItems);
            }
static addManySchools = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OrderReport.addSchools($this, items[i]);
                }
            }
static addSchools = ($this, item) => {
                if ($this.Schools == null) $this.Schools = [];
                if (item == null || $this.Schools.indexOf(item) > -1) return;
                $this.Schools.push(item);
}
static addRangeSchools = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OrderReport.addSchools($this, item));
            }
static removeSchools = ($this, item) => {
                if ($this == null || $this.Schools == null || $this.Schools.indexOf(item) === -1) return;
                var _index = $this.Schools.indexOf(item);
                $this.Schools.splice(_index, 1);
}
static clearSchools = ($this) => { $this.Schools = null; }
static setTotals = ($this, items) => {
                if (items == null) items = [];
                if ($this.Totals == null) $this.Totals = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Totals.length > 0) {
                    Domain.OrderReport.removeTotals($this, $this.Totals[0]);
                }

                Domain.OrderReport.addManyTotals($this, copyItems);
            }
static addManyTotals = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OrderReport.addTotals($this, items[i]);
                }
            }
static addTotals = ($this, item) => {
                if ($this.Totals == null) $this.Totals = [];
                if (item == null || $this.Totals.indexOf(item) > -1) return;
                $this.Totals.push(item);
}
static addRangeTotals = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OrderReport.addTotals($this, item));
            }
static removeTotals = ($this, item) => {
                if ($this == null || $this.Totals == null || $this.Totals.indexOf(item) === -1) return;
                var _index = $this.Totals.indexOf(item);
                $this.Totals.splice(_index, 1);
}
static clearTotals = ($this) => { $this.Totals = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OrderReportKey == null || $this.OrderReportKey == 0;
            }


}